// extracted by mini-css-extract-plugin
export default {"group":"common-components-ActionGroup-ActionGroup-ActionGroup__group--VA5h2"};